import { createFileRoute } from '@tanstack/react-router';
import { MeasurementsStep } from '../steps/MeasurementsStep.js';

export const Route = createFileRoute('/_planner/planner/measure')({
  component: MeasurementsStep,
});
